module.exports = __webpack_public_path__ + "img/produto_zooxsmart_pass.926c658b.png";